/**
 * Specialist registry — client-side, presentation-only.
 *
 * Single persona:
 *   - `fernando` (Fernando Ortega) — surfaces on Broker listings, the
 *     Fleet modal, B2B demand pillar pages (`/renta-naves-industriales`,
 *     `/renta-bodegas-comerciales`), AND host acquisition pages
 *     (`/anfitrion/tradicional`, `/anfitrion/negocio`). Supply pages set
 *     `tone="supply"` on `SpecialistCard` for audience-correct copy.
 *
 * The data here drives only the trust card (name + photo + whether to
 * render a WhatsApp button). Routing — the actual WhatsApp number,
 * HubSpot owner, Firebase identity — is owned by the server (`OWNERS`
 * array in `spotme-server/src/datasources/HubSpot/constants.ts`). Keep
 * public-facing fields here; do NOT duplicate identifiers the server
 * uses for routing.
 *
 * Empty `photoUrl` is treated as "not configured yet" — `SpecialistCard`
 * renders `null` when photo is missing, so a half-configured specialist
 * silently no-ops rather than shipping a broken image.
 */

import { SpecialistKey } from 'src/lib/listingVariants/types'

export interface Specialist {
  key: NonNullable<SpecialistKey>
  name: string
  photoUrl: string
  /**
   * Whether to render the WhatsApp CTA on the specialist trust card.
   * The actual phone is the corporate SpotMe WhatsApp (see
   * `buildWhatsappUrl` default) — we don't expose specialist-direct
   * numbers in v1 so the chatbot can triage and the lead is captured
   * uniformly.
   */
  hasWhatsapp: boolean
}

export const SPECIALISTS: Record<NonNullable<SpecialistKey>, Specialist> = {
  fernando: {
    key: 'fernando',
    name: 'Fernando Ortega',
    photoUrl:
      'https://spotme-images.s3.us-west-1.amazonaws.com/fef9ed11-e21e-4c95-a668-e6bac34345c0',
    hasWhatsapp: true
  }
} as const

export function getSpecialist(
  key: SpecialistKey | undefined | null
): Specialist | null {
  if (!key) return null
  return SPECIALISTS[key] ?? null
}
